import { ChangeEvent, Key, MouseEvent } from 'react'

import { TableRow } from '~/features/guild/components/table/types'

/**
 * 页码变更时的处理器 normalizer，自动过滤不存在的处理器
 * @param event
 * @param page
 * @param handler
 */
export const handlePageUpdate = (
  event: MouseEvent<HTMLButtonElement> | null,
  page: number,
  handler?: (event: MouseEvent<HTMLButtonElement> | null, page: number) => void
) => {
  if (!handler) return
  if (Number.isNaN(page)) return

  handler(event, page + 1)
}

/**
 * 页大小变更时的处理器 normalizer，自动自动过滤不存在的处理器、不合理的页大小数值
 * @param e 事件
 * @param handler 处理器
 * @returns
 */
export const handlePageSizeUpdate = (
  e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  handler?: (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, pageSize: number) => void
) => {
  if (!handler) return
  if (!e || !e.target || Number.isNaN(parseInt(e.target.value))) return

  handler(e, parseInt(e.target.value))
}

export const keyOfRow = <T extends TableRow<T, Props>, Props = {}>(row: T, index: number, tableProps?: Props): Key => {
  if (row.id !== undefined) {
    return row.id
  }
  if (row.getId !== undefined) {
    return row.getId({ props: tableProps, row })
  }

  return index
}
